import * as React from 'react';
var RangeContext = /*#__PURE__*/React.createContext({});
export default RangeContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-picker/es/RangeContext.js
// module id = 273
// module chunks = 0